//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function disassociateTagService(idLead, idTag) {
    try {
        await api.delete(`/leads/${idLead}/tags/${idTag}`);
        toast.success("Tag disassociada com sucesso");
        return true;
    } catch {
        toast.error("Erro ao disassociar tag");
        return false;
    }
}